// frontend/src/components/InvitePathModal.js
import React from 'react';
import './InvitePathModal.css'; // Стили компонента

/**
 * Компонент модального окна для отображения пути приглашений между пользователями
 * @param {Object} props - Свойства компонента
 * @param {Array} props.invitePathData - Массив пользователей, образующих путь
 * @param {boolean} props.isLoadingPath - Флаг загрузки данных пути
 * @param {string} props.errorPath - Сообщение об ошибке, если есть
 * @param {function} props.onClose - Функция для закрытия модального окна
 */
const InvitePathModal = ({ invitePathData, isLoadingPath, errorPath, onClose }) => {
  // Если данных нет, не рендерим ничего
  if (!invitePathData || invitePathData.length === 0) {
    if (!isLoadingPath && !errorPath) {
      return null;
    }
  }

  // Получаем первого и последнего пользователя из пути, если они есть
  const currentUser = invitePathData && invitePathData.length > 0 ? invitePathData[0] : null;
  const targetUser = invitePathData && invitePathData.length > 1 ? invitePathData[invitePathData.length - 1] : null;

  // Находим точку перегиба (общего предка)
  let commonAncestorIndex = -1;
  if (invitePathData && invitePathData.length > 1) {
    for (let i = 0; i < invitePathData.length - 1; i++) {
      if (invitePathData[i].telegram_id === invitePathData[i + 1].telegram_id) {
        commonAncestorIndex = i;
        break;
      }
    }
    // ... (остальная логика поиска предка, если нужна) ...
     if (commonAncestorIndex === -1) {
         for (let i = 0; i < invitePathData.length; i++) {
             if (invitePathData[i].telegram_id === '434832654' ||
                 (invitePathData[i].chain_info && invitePathData[i].chain_info.is_owner)) {
                 commonAncestorIndex = i;
                 break;
             }
         }
     }
     if (commonAncestorIndex === -1 && invitePathData.length > 0) { // Добавил проверку invitePathData.length
         commonAncestorIndex = Math.floor(invitePathData.length / 2);
     }
  }


  return (
    <div className="invite-path-modal-overlay" onClick={onClose}>
      {/* Останавливаем всплытие события для контента модалки */}
      <div className="invite-path-modal-content" onClick={e => e.stopPropagation()}>
        <div className="invite-path-modal-header">
          <h2>Путь приглашений</h2>
          <button className="invite-path-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="invite-path-modal-subheader">
          {isLoadingPath ? (
            <p>Загрузка пути приглашений...</p>
          ) : errorPath ? (
            <p className="error-text">Ошибка: {errorPath}</p>
          ) : invitePathData && invitePathData.length > 1 ? (
            <>
              <p>Путь от <strong>{currentUser?.name || currentUser?.username || 'Вас'}</strong> до <strong>{targetUser?.name || targetUser?.username || 'пользователя'}</strong></p>
              {commonAncestorIndex >= 0 && invitePathData[commonAncestorIndex] && ( // Добавил проверку на существование элемента
                <p style={{ fontSize: '12px', color: '#666' }}>
                  Общий предок: <strong>{invitePathData[commonAncestorIndex]?.name || invitePathData[commonAncestorIndex]?.username || `ID:${invitePathData[commonAncestorIndex]?.telegram_id}`}</strong> (№{commonAncestorIndex + 1} в пути)
                </p>
              )}
            </>
          ) : invitePathData && invitePathData.length === 1 ? ( // Случай когда в пути только один пользователь (например, сам на себя)
             <p>Информация о пользователе <strong>{currentUser?.name || currentUser?.username || 'Вас'}</strong></p>
          ) : (
            <p>Путь не найден или не определен</p> // Сообщение если путь пуст
          )}
        </div>

        <div className="path-list">
          {isLoadingPath ? (
            <div className="path-loading">Загрузка...</div>
          ) : errorPath ? (
            <div className="path-error">{errorPath}</div>
          ) : invitePathData && invitePathData.map((user, index) => (
            // Используем Fragment чтобы не добавлять лишних div
            <React.Fragment key={`${user.telegram_id}-${index}`}> {/* Добавляем index к ключу на случай дубликатов ID */}
              <div className={`path-user-item
                ${index === 0 ? 'current-user' : ''}
                ${index === invitePathData.length - 1 && index !== 0 ? 'target-user' : ''}
                ${index === commonAncestorIndex ? 'common-ancestor' : ''}
              `}>
                <div className="path-user-avatar">
                  <img
                    src={user.avatar || '/avatars/default-avatar.png'}
                    alt={`Аватар ${user.name || user.username}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/avatars/default-avatar.png';
                    }}
                  />
                </div>
                <div className="path-user-info">
                  <h3>
                    {user.name || user.username || `Пользователь ${user.telegram_id}`}
                    {index === 0 && <span className="path-user-badge current">Вы</span>}
                    {index === invitePathData.length - 1 && index !== 0 && <span className="path-user-badge target">Цель</span>}
                    {index === commonAncestorIndex && <span className="path-user-badge ancestor">Общий предок</span>}
                  </h3>
                  {user.city && <p className="path-user-location">📍 {user.city}</p>}
                  {/* Отображение тегов/категорий */}
                  {(user.tags || user.categories) && (user.tags?.length > 0 || user.categories?.length > 0) && (
                     <div className="path-user-tags">
                       {(user.categories || user.tags).map((tag, idx) => ( // Проверяем оба поля
                         <span key={`tag-${user.telegram_id}-${idx}`} className="path-user-tag">
                           {tag}
                         </span>
                       ))}
                     </div>
                   )}
                </div>
              </div>

              {/* --- СОЕДИНИТЕЛЬ (ТОЛЬКО СТРЕЛКА) --- */}
              {index < invitePathData.length - 1 && (
                <div className="path-connector">
                  {/* Линия удалена */}
                  <div className="connector-arrow" title="Направление приглашения">
                    {/* Передаем данные СЛЕДУЮЩЕГО пользователя */}
                    {invitePathData[index+1] && getArrowDirection(index, commonAncestorIndex, user, invitePathData[index + 1])}
                  </div>
                </div>
              )}
              {/* --- КОНЕЦ СОЕДИНИТЕЛЯ --- */}

            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

// --- Функция getArrowDirection ---
const getArrowDirection = (index, commonAncestorIndex, currentUser, nextUser) => {
  const currentName = currentUser.name || currentUser.username || `ID:${currentUser.telegram_id}`;
  const nextName = nextUser.name || nextUser.username || `ID:${nextUser.telegram_id}`;

  let inviterName, inviteeName;
  let arrowDirection = null;
  let arrowElement = null;

  // Определяем направление на основе данных invited_by
  if (nextUser.invited_by?.telegram_id === currentUser.telegram_id) {
    arrowDirection = 'forward'; // Стрелка вниз
    inviterName = currentName;
    inviteeName = nextName;
    arrowElement = (
      // !!! ИЗМЕНЕНО: Увеличен размер стрелки !!!
      <svg width="30" height="30" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <path d="M50 100L0 50H25V0H75V50H100L50 100Z" fill="#9ccc65"/> {/* Зеленоватый */}
      </svg>
    );
  }
  else if (currentUser.invited_by?.telegram_id === nextUser.telegram_id) {
    arrowDirection = 'backward'; // Стрелка вверх
    inviterName = nextName;
    inviteeName = currentName;
    arrowElement = (
      // !!! ИЗМЕНЕНО: Увеличен размер стрелки !!!
      <svg width="30" height="30" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <path d="M50 0L100 50H75V100H25V50H0L50 0Z" fill="#9ccc65"/> {/* Зеленоватый */}
      </svg>
    );
  }
  else {
    // Резервная логика (если invited_by не совпадает) - СТРЕЛКА ВНИЗ
    arrowDirection = 'forward';
    inviterName = currentName; // Предполагаем что текущий пригласил следующего
    inviteeName = nextName;
    arrowElement = (
      // !!! ИЗМЕНЕНО: Увеличен размер стрелки !!!
      <svg width="30" height="30" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <path d="M50 100L0 50H25V0H75V50H100L50 100Z" fill="#cccccc"/> {/* Серый для неопределенной связи */}
      </svg>
    );
  }

  return (
    <span
      title={`${inviterName} пригласил ${inviteeName}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {arrowElement}
    </span>
  );
};


export default InvitePathModal;